import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/services/app/app.service";
import { coordinateValidator } from 'src/app/model/latitude-longitude-validation';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';

@Component({
  selector: 'app-add-time-for-specific-job',
  templateUrl: './add-time-for-specific-job.component.html',
  styleUrls: ['./add-time-for-specific-job.component.scss']
})
export class AddTimeForSpecificJobComponent {

  public empDetails: any;
  timeForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddTimeForSpecificJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    public timeClockService: TimeClockService,
  ) {


    this.empDetails = data;

    this.timeForm = this.fb.group({
      startTime: ['', [Validators.required]],
      endTime: ['', [Validators.required]],
      breakStartTime: ['', []],
      breakEndTime: ['', []],
      clockInLatitude: ['', [ coordinateValidator('clockInLatitude')]], 
      clockInLongitude: ['', [ coordinateValidator('clockInLongitude')]],  
      clockOutLatitude: ['', [ coordinateValidator('clockOutLatitude')]], 
      clockOutLongitude: ['', [ coordinateValidator('clockOutLongitude')]]
    });
    
  }


  onCancel() {
    this.dialogRef.close()
  }

  onSubmit() {  
    if (this.timeForm.valid) {
      const formData = this.timeForm.value;

      let obj = {
        "j_id": this.empDetails.id,
        "em_i": this.empDetails.employee_id,
        "date": this.empDetails.date,
        "st_ti": formData.startTime,
        "ed_ti": formData.endTime,
        "br_tii": formData.breakStartTime,
        "br_tio": formData.breakEndTime,
        "cl_in_lat": formData.clockInLatitude,
        "cl_in_long": formData.clockInLongitude,
        "cl_out_lat": formData.clockOutLatitude,
        "cl_out_long": formData.clockOutLongitude
      }

      this.spinner.show();
      this.timeClockService.addSeprateEmployeeTime(obj).subscribe({
        next: (success: any) => {
          this.spinner.hide();
          if (success.status == 200) {
            this.appService.showToastMessage("success", success["msg"]);
            this.dialogRef.close()
          }
        },
        error: (error: any) => {

        }
      })

    } else {

      Object.keys(this.timeForm.controls).forEach((field) => {
        const control = this.timeForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });


      console.error('Form is invalid', this.timeForm.errors);
    }
  }
}
